<script>
	import { getContext, onDestroy } from 'svelte';
	import { L, key } from './leaflet.js';

	const { getMap } = getContext(key);
	const map = getMap();

	export let location;
	export let label;
	export let click;

	const marker = L.marker(location).addTo(map);
	marker.title = label;

	if(click)
	{
		marker.on("click",function(){click(label);});
		
	}

	onDestroy(() => {
		marker.remove();
	});

</script>
